import styled from 'styled-components';

export const SettingsPaneStyled = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-flow: column;

`;

export const SPGeneralStyled = styled.div`
  margin-top: 5px;
  width: calc(100% - 10px);
  padding: 5px;
  display: grid;
  grid-template-columns: auto auto auto;
  grid-gap: 10px;

  > select {
    grid-column-start: 2;
    grid-column-end: 4;
  }
`;

export const SPOpenImgStyled = styled.div`
  width: 100%;
  margin-top: 5px;
  display: grid;
  grid-template-columns: auto 35px;
  grid-row-gap: 5px;
`;